import { useState, useEffect } from 'react'

const HydrationGuard = ({ children }: { children: React.ReactNode }) => {
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- safe: runs once after mount (empty deps) to flip hydration flag
    setIsHydrated(true)
  }, [])

  return isHydrated ? children : null
}

export default HydrationGuard
